module.exports = __webpack_public_path__ + "static/media/fedpat-logo-alta.5252b1ba.png";